<template>

    <rkm-tabs v-model="tabIndex">

        <rkm-tab
            title="AGENDAR EXAMES"
            @click.prevent="setAgendamento()"
        >

            <rkm-form ref="Form">

                <tab-agendar-exames
                    ref="TabAgendarExames"
                    :data="{form, model}"
                    :feriado="feriado"
                    :paciente="paciente"
                    :agendamento="agendamento"
                    :unidades="unidades"
                    :diasCalendario="diasCalendario"
                    :vagas="vagas"
                    :jornadas="jornadas"
                    :index="index"
                    :horarioAgendamento="horarioAgendamento"
                    :regulacaoSolicitacao="regulacaoSolicitacao"
                    :reagendar="reagendar"
                    :loaded="loaded"
                    @backTabs="backTabs"
                    @messageAdd="messageAdd"
                    @loadDiasCalendario="loadDiasCalendario"
                    @setFields="setFields"
                    @loadInfraestrutura="loadInfraestrutura"
                    @loadVagas="loadVagas"
                    @loadCalendario="loadCalendario"
                    @agendarAmbulatorioAtendimento="agendarAmbulatorioAtendimento"
                    @multipleAmbulatorioAtendimento="multipleAmbulatorioAtendimento"
                    :datasBloqueadas="datasBloqueadas"
                />
            </rkm-form>
        </rkm-tab>

        <rkm-tab
            v-if="!hideAgendamentos"
            title="EXAMES AGENDADOS"
            @click.prevent="setAgendamento()"
        >
            <tab-exames-agendados
                ref="TabExamesAgendados"
                :data="{form, model}"
                :paciente="paciente"
                @handleAlter="handleAlter"
            />
        </rkm-tab>

        <ModalPermissao
            ref="RkmModalPermissao"
            origem="listagem"
            @handlePermission="handlePermission"
        />

        <ModalPacienteCadastroSimplificado
            @save="reloadPaciente($event)"
            ref="ModalPacienteCadastroSimplificado"
        />
    </rkm-tabs>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

//Moment
import moment from 'moment'

// Mixins.
import { formats, repository, stringCase, data, object, error, printExameLaboratorial } from '@/mixins'

// Enums.
import modulo from '@/enums/cadastro/feriado/modulo'
import abrangencia from '@/enums/cadastro/feriado/abrangencia'
import impressaoAgendamento from '@/enums/exame-laboratorial/impressaoAgendamento'
import racaCor from '@/enums/cadastro/cidadao/racaCor'

// Components.
import TabExamesAgendados from '@/components/exame-laboratorial/agendamento-exame/tabs/agendados/Index'
import TabAgendarExames from '@/components/exame-laboratorial/agendamento-exame/tabs/cadastro/Form'
import ModalPermissao from '@/components/exame-laboratorial/agendamento-exame/tabs/cadastro/components/permissao/Modal'
import ModalPacienteCadastroSimplificado from '@/components/cadastro/paciente/components/cadastro-simplificado/Modal'

// Utils
import validaCpf from '@/utils/validations/cpf'
import validaCns from '@/utils/validations/cns'

export default {
    components: {
        TabExamesAgendados,
        TabAgendarExames,
        ModalPermissao,
        ModalPacienteCadastroSimplificado
    },
    computed: {
        unidades(){

            let unidades = this.form.unidades ? this.form.unidades : []

            if (!this.form.isSupervisor && !this.isFromRegulacao) {

                unidades = unidades.filter(u => u.id == this.form.unidadeId)
            }

            return unidades
        },
        isFromRegulacao() {

            return !!this.regulacaoSolicitacao
        },
        isReagendar() {

            return !!this.reagendar
        },
    },
    created() {
        this.repositories = {
            agendamento: this.getConectaSusRepository('exameLaboratorial.agendamentoExame'),
            impressao: this.getConectaSusRepository('impressao.exameLaboratorial'),
        }
    },
    data: () => ({
        additionals: null,
        form: {},
        model: {
            cadastro: [],
            inclusao: [],
            medicoSolicitante: null,
            pacienteId: null
        },
        tabIndex: 0,
        index: null,
        paciente: {
            cidadaoId: null,
            id: null,
            nome: null,
            preferenciaNomeId: null,
            nomeSocial: '',
            prontuario: null,
            cpf: null,
            cns: null,
            telefone: null,
            dataNascimento: null,
            idade: null,
            anos: null,
            meses: null,
            dias: null,
            sexo: null,
            sexoId: null,
            sexoDescricao: '',
            nomeMae: '',
            unidadeReferencia: '',
            racaCor: '',
        },
        agendamento: {
            agendamentoId: null,
            agendamentoNumero: null,
            data: null,
            horaInicial: null,
            infraestruturaId: null,
            infraestruturaNome: '',
            unidadeId: null,
            unidadeNome: '',
            unidadeDisabled: false,
            laboratorioId: null,
            laboratorioNome: '',
            laboratorioInfraestruturaId: null,
            laboratorioInfraestruturaNome: '',
            selecionado: false,
            pacienteId: '',
            sexoId: '',
            medicoNome: '',
            medicoId: null,
            medicoSolicitante: null,
            responsavel: null,
            dataMenstruacao: null,
            gestante: false,
            urgente: false,
            coletaUnidadeId: null,
            coletaNome: '',
            coletaInfraestruturaId: null,
            coletaInfraestruturaNome: '',
            medicamentos: '',
            suspeita: '',
            observacao: '',
            showInfo: false,
            supervisor: false,
            jornadaId: null,
            supervisorId: null,
            incluido: [],
            impressao: true,
            alterado: false,
            ambulatorioAtendimento: false,
            carregaJornada: false,
        },
        utils: {
            validaCpf,
            validaCns
        },
        enums: {
            modulo,
            abrangencia,
            impressaoAgendamento,
            racaCor
        },
        diasCalendario: [],
        vagas: [],
        jornadas: [],
        horarioAgendamento: null,
        feriado: [],
        loaded: false,
        datasBloqueadas: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handlePermission(supervisorId, item, index){

            item.supervisorId = supervisorId

            this.handleAlter(item, index)
        },
        load() {

            this.setLoading()

            this.repositories.agendamento.show(this.id)
                .then(({ data }) => {

                    const exibirExameAmbulatorioAtendimento = data.form.exibirExameAmbulatorioAtendimento

                    data.form.exibirExameAmbulatorioAtendimento = false

                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model
                    this.feriado = data.form.feriados
                    this.datasBloqueadas = data.form.datasBloqueadas

                    this.loadPaciente(data.form.paciente, exibirExameAmbulatorioAtendimento)
                    this.loadFields(this.form)

                    this.$nextTick().then(() => {

                        this.tabRefs = [
                            this.$refs.TabExamesAgendados,
                            this.$refs.TabAgendarExames,
                        ]

                        this.loaded = true
                    })

                    this.$emit('loaded', {additionals: this.additionals, paciente: this.paciente})
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadPaciente(paciente, exibirExameAmbulatorioAtendimento) {

            this.paciente.cidadaoId = paciente.cidadaoId
            this.paciente.id = paciente.pacienteId
            this.paciente.nome = paciente.cidadaoNome
            this.paciente.preferenciaNomeId = paciente.cidadaoPreferenciaNomeId
            this.paciente.nomeSocial = paciente.cidadaoNomeSocial
            this.paciente.prontuario = paciente.pacienteProntuario
            this.paciente.cpf = paciente.cidadaoCpf
            this.paciente.cns = paciente.cidadaoCns
            this.paciente.telefone = paciente.cidadaoTelefones
            this.paciente.dataNascimento = paciente.cidadaoDataNascimento
            this.paciente.idade = paciente.cidadaoIdade
            this.paciente.anos = paciente.cidadaoIdadeAnos
            this.paciente.meses = paciente.cidadaoIdadeMeses
            this.paciente.dias = paciente.cidadaoIdadeDias
            this.paciente.sexoId = paciente.sexoId
            this.paciente.sexoDescricao = paciente.sexoDescricao
            this.paciente.nomeMae = paciente.cidadaoNomeMae
            this.paciente.unidadeReferencia = paciente.unidadeNomeFantasia
            this.paciente.classificacaoId = paciente.pacienteClassificacaoId
            this.paciente.racaCor = paciente.cidadaoRacaCor

            if ((paciente.cidadaoCpf !== null && !this.utils.validaCpf(paciente.cidadaoCpf))
                 || (paciente.cidadaoCns !== null && !this.utils.validaCns(paciente.cidadaoCns))
                 || !paciente.cidadaoTelefones || !paciente.cidadaoDataNascimento
                 || !paciente.sexoId) {

                    const confirm = async () => {

                        this.$emit('handleAtualizaPaciente')
                    }

                    const cancel = async () => {

                        this.$emit('handleExitPaciente')
                    }

                    const msg = 'O cadastro do paciente está incompleto. Para realizar o agendamento é necessário' +
                        ' atualiza-lo. Deseja atualizar?'

                        this.showConfirmation(msg, confirm, cancel)

                    return false
            }

            if (!paciente.cidadaoCpf && !paciente.cidadaoCns) {
                this.showWarningNotification(
                    'Paciente com cadastro incompleto. O agendamento poderá ser realizado, mas o fechamento da coleta exigirá CPF e CNS preenchidos.',
                    async () => {
                        this.form.exibirExameAmbulatorioAtendimento = exibirExameAmbulatorioAtendimento
                    }
                )

                return false
            }

            this.form.exibirExameAmbulatorioAtendimento = exibirExameAmbulatorioAtendimento
        },
        loadFields(form) {

            if (this.isFromRegulacao) {

                if (this.regulacaoSolicitacao.exameLaboratorialAgendamentoId) {

                    const itemAgendamento = this.model.agendamentos
                        .find(a => a.agendamentoId === this.regulacaoSolicitacao.exameLaboratorialAgendamentoId)

                    const index = this.model.agendamentos.indexOf(itemAgendamento)

                    if (!itemAgendamento.alterarAgendamento) {

                        const confirm = async () => {

                            this.$refs.RkmModalPermissao.open(itemAgendamento, index)

                            return false
                        }

                        const msg = 'Já existe coleta lançada no agendamento, para continuar é necessário informar' +
                            ' os dados do supervisor. Deseja continuar?'

                        this.showConfirmation(msg, confirm)

                        return false
                    } else {

                        this.handleAlter(itemAgendamento, index)
                    }
                }
                else {

                    this.agendamento.medicoSolicitante = {
                        id: this.regulacaoSolicitacao.usuarioSolicitanteId,
                        cidadaoNome: this.regulacaoSolicitacao.usuarioSolicitanteNome,
                    }

                    this.agendamento.urgente = this.regulacaoSolicitacao.isUrgente
                    this.agendamento.suspeita = this.regulacaoSolicitacao.hipoteseDiagnosticaJustificativa

                    if (this.unidades.find(u => u.id === this.regulacaoSolicitacao.unidadeSolicitanteId)) {

                        this.agendamento.unidadeId = this.regulacaoSolicitacao.unidadeSolicitanteId

                        this.setFields('unidade')
                    }
                    else {

                        this.showWarningNotification('A unidade solicitante não está disponível para seleção.')
                    }
                }
            }
            else if (this.isReagendar) {

                this.handleReagendar()
            }
            else if (!this.hasIndex()) {

                let unidadeLogada = this.unidades.find(u => u.id === form.unidadeId)

                if (unidadeLogada) {

                    this.agendamento.unidadeId = form.unidadeId
                    this.agendamento.infraestruturaId = form.infraestruturaId
                }

                let unidadeColeta = form.unidadesParametrizada.find(u => u.id == form.unidadeId)

                if (unidadeColeta) {

                    let infraestrutura = unidadeColeta.infraestruturas.find(u => u.id == form.infraestruturaId
                        && u.unidadeSolicitanteInfraestruturaId == form.infraestruturaId)

                    if (infraestrutura) {
                        this.agendamento.coletaUnidadeId = form.unidadeId
                        this.agendamento.coletaInfraestruturaId = form.infraestruturaId
                    }
                }
            }

            if (form.paciente.cidadaoIdadeAnos < 18 || form.paciente.cidadaoIdadeAnos >= 60) {

                this.agendamento.responsavel = form.cidadaoNomeMae
            }
        },
        setAgendamento() {

            this.agendamento = {
                agendamentoId: null,
                agendamentoNumero: null,
                data: null,
                horaInicial: null,
                infraestruturaId: null,
                infraestruturaNome: '',
                unidadeId: null,
                unidadeNome: '',
                unidadeDisabled: false,
                laboratorioId: null,
                laboratorioNome: '',
                laboratorioInfraestruturaId: null,
                laboratorioInfraestruturaNome: '',
                selecionado: false,
                pacienteId: '',
                sexoId: '',
                medicoNome: '',
                medicoId: null,
                medicoSolicitante: null,
                responsavel: null,
                dataMenstruacao: null,
                gestante: false,
                urgente: false,
                coletaUnidadeId: null,
                coletaNome: '',
                coletaInfraestruturaId: null,
                coletaInfraestruturaNome: '',
                medicamentos: '',
                suspeita: '',
                observacao: '',
                showInfo: false,
                supervisor: false,
                jornadaId: null,
                supervisorId: null,
                incluido: [],
                impressao: true,
                alterado: false,
            }

            this.index = null
            this.horarioAgendamento = null
            this.vagas = []

            this.loadFields(this.form)
            this.loadDays()

            this.$nextTick(() => this.loadVagas())
            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        setFields(field) {

            if (field == 'unidade') {

                this.agendamento.infraestruturaId = null
                this.agendamento.laboratorioId = null
                this.agendamento.laboratorioInfraestruturaId = null
                this.agendamento.coletaUnidadeId = null
                this.agendamento.coletaInfraestruturaId = null
                this.agendamento.alterado = true

                let infraestruturaPrincipal = this.form.unidades.find(u =>
                    u.id === this.agendamento.unidadeId).infraestruturas

                this.loadInfraestrutura(infraestruturaPrincipal)

                if (this.agendamento.infraestruturaId) {

                    this.loadUnidadeColeta()
                }
            } else if (field == 'infraestruturaId') {

                this.agendamento.laboratorioId = null
                this.agendamento.laboratorioInfraestruturaId = null
                this.agendamento.coletaUnidadeId = null
                this.agendamento.coletaInfraestruturaId = null
                this.agendamento.alterado = true

                if (this.agendamento.infraestruturaId) {

                    this.loadUnidadeColeta()
                }
            } else if (field == 'coletaUnidadeId') {

                this.agendamento.laboratorioId = null
                this.agendamento.laboratorioInfraestruturaId = null
                this.agendamento.alterado = true
            } else if (field == 'coletaInfraestruturaId' && !this._supressLoadVagas) {

                this.agendamento.laboratorioId = null
                this.agendamento.laboratorioInfraestruturaId = null
                this.agendamento.alterado = true
                this.loadVagas()
            } else if (field == 'laboratorioId' && !this.agendamento.laboratorioId) {

                this.agendamento.laboratorioInfraestruturaId = null
            }

            if (field !== 'laboratorioId' && field !== 'laboratorioInfraestruturaId') {

                this.loadDays()
            }

            this.$emit('agendamentoAtual', this.agendamento)
        },
        loadUnidadeColeta() {

            if (!this.hasIndex()) {

                let unidadeColeta = this.form.unidadesParametrizada
                    .filter(unidade => unidade.coleta && unidade.infraestruturas
                    .find(infraestrutura => infraestrutura.unidadeSolicitanteInfraestruturaId == this.agendamento.infraestruturaId))

                if (unidadeColeta.length === 1) {
                    this.agendamento.coletaUnidadeId = unidadeColeta[0].id
                }
            }
        },
        loadInfraestrutura(infraestrutura) {

            if (this.isFromRegulacao) {

                if (infraestrutura.find(i => i.id === this.regulacaoSolicitacao.infraestruturaSolicitanteId)) {

                    this.agendamento.infraestruturaId = this.regulacaoSolicitacao.infraestruturaSolicitanteId
                }
                else {

                    this.showWarningNotification('O local de atendimento solicitante não está disponível para seleção.')
                }
            }
            else {

                const infraestruturaPrincipal = infraestrutura.find(u => u.principal)

                if (infraestruturaPrincipal) {
                    this.agendamento.infraestruturaId = infraestruturaPrincipal.id
                }
            }
        },
        hasIndex() {

            return this.index === null ? false : true
        },
        save(){

            if(this.tabIndex == 0){

                this.$refs.Form.validate()
                    .then(valid => {

                        if (!valid) return
                        if (!this.validateFields()) return

                        this.setLoading()

                        this.repositories.agendamento.store(this.prepareData())
                            .then(({ data }) => {

                                if (Object.keys(data).length === 0) {
                                    this.$emit('save')
                                } else {
                                    const printData = this.preparePrint(data)

                                    if (this.isFromRegulacao || this.hasPrint || this.hasAmbulatorio) {
                                        this.handlePrintItem(printData)
                                    }

                                    this.$emit('save', printData)
                                }
                            })
                            .catch(error => { this.handleError(error); this.setAgendamento() })
                            .finally(() => this.unsetLoading())
                    })
            } else {

                this.setLoading()

                this.repositories.agendamento.store(this.prepareData())
                    .then(({ data }) => {

                        this.showSaveNotification()
                        this.$emit('save', data)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        validateFields() {

            if (this.agendamento.data === null) {

                this.showValidationNotification('Obrigatório selecionar uma data.')

                return false
            }

            if (this.agendamento.horaInicial === null) {

                this.showValidationNotification('Obrigatório selecionar um horário.')

                return false
            }

            if (this.agendamento.incluido.length == 0) {

                this.showValidationNotification('Obrigatório atribuir pelo menos um exame no agendamento.')

                return false
            }

            return true
        },
        preparePrint(data) {

            let prazoEntrega = null
            let dataEntrega = null

            data.incluido.forEach(exame => {

                if (exame.prazoEntrega !== null) {

                    if (prazoEntrega == null) {
                        prazoEntrega = exame.prazoEntrega
                    } else {

                        if (prazoEntrega < exame.prazoEntrega) {
                            prazoEntrega = exame.prazoEntrega
                        }
                    }
                }
            })

            dataEntrega = prazoEntrega !== null
                ? moment(data.data).add(prazoEntrega, 'days').format('DD/MM/YYYY')
                : ''

            let agendamento = {

                pacienteNome: this.paciente.nome,
                pacienteNomeSocial: this.paciente.nomeSocial,
                prontuario: this.paciente.prontuario,
                cpf: this.formatCpf(this.paciente.cpf),
                nomeResponsavel: data.responsavel,
                dataNascimento: this.paciente.dataNascimento.split("-").reverse().join("/"),
                idade: this.paciente.anos > 1
                    ? `${this.paciente.anos} ANOS`
                    : `${this.paciente.anos} ANO` ,
                agendamentoNumero: data.agendamentoNumero,
                regulacaoSolicitacaoNumero: data.regulacaoSolicitacaoNumero,
                medicoNome: data.medicoNome,
                grupoExameNome: data.grupoExameNome,
                observacao: data.observacao,
                data: moment(data.data).format('DD/MM/YYYY'),
                examesIncluido: data.incluido,
                horaExame: data.horaInicial,
                unidade: data.unidadeNome,
                endereco: data.unidadeEndereco,
                numeroEndereco: data.unidadeNumeroEndereco,
                bairro: data.unidadeBairro,
                telefone: data.unidadeTelefone,
                tipo: data.unidadeTipo,
                cep: data.unidadeCep,
                localColeta: data.coletaNome,
                enderecoColeta: data.coletaEndereco,
                numeroEnderecoColeta: data.coletaNumeroEndereco,
                bairroColeta: data.coletaBairro,
                telefoneColeta: data.coletaTelefone,
                tipoColeta: data.coletaTipo,
                cepColeta: data.coletaCep,
                laboratorio: data.laboratorioNome,
                enderecoLaboratorio: data.laboratorioEndereco,
                numeroEnderecoLaboratorio: data.laboratorioNumeroEndereco,
                bairroLaboratorio: data.laboratorioBairro,
                telefoneLaboratorio: data.laboratorioTelefone,
                tipoLaboratorio: data.laboratorioTipo,
                cepLaboratorio: data.laboratorioCep,
                logotipo: data.cliente.logotipo,
                nomePrefeitura: data.cliente.nome,
                ramoAtividade: data.cliente.sistema.ramoAtividade.nome,
                mensagemProtocolo: data.mensagemProtocolo,
                sistemaNome: data.cliente.sistema.nome,
                sistemaVersao: data.cliente.sistema.versao,
                usuario: data.usuario,
                usuarioNomeSocial: data.usuarioNomeSocial ? data.usuarioNomeSocial : null,
                urgente: data.urgente,
                dataEntrega: dataEntrega,
                impressaoAgendamentoTipoId: this.form.impressaoAgendamentoTipoId,
                regulacaoMensagemComprovanteAgendamento: this.isFromRegulacao
                    ? data.regulacaoMensagemComprovanteAgendamento
                    : null
            }

            return agendamento
        },
        prepareData() {

            const agendamento = this.clone(this.agendamento)
            const model = this.clone(this.model)

            if(agendamento.jornadaId !== null){

                agendamento.medicoId = agendamento.medicoSolicitante.id
                agendamento.medicoNome = agendamento.medicoSolicitante.nome
                agendamento.regulacaoSolicitacaoId = this.regulacaoSolicitacao?.id ?? null

                if (agendamento.dataMenstruacao) {

                    agendamento.dataMenstruacao = moment(agendamento.dataMenstruacao).format('YYYY-MM-DD')
                }

                if (agendamento.agendamentoId == null) {

                    agendamento.agendamentoId = this.uniqueId('agendamento' + new Date().getTime())

                    model.agendamentos.push(agendamento)
                } else {

                    const objIndex = model.agendamentos.findIndex((obj => obj.agendamentoId == agendamento.agendamentoId));

                    this.$set(model.agendamentos, objIndex, this.clone(agendamento))
                }
            }

            model.agendamentosNotSave = model.agendamentos.filter(agendamento => agendamento.alterado)
            model.pacienteId = this.paciente.id

            delete(model.agendamentosSearch)

            return this.camelObjectKeysToSnakeRecursive(model)
        },
        handleAlter(item, index ) {

            this.index = index
            this.agendamento.carregaJornada = false
            this.agendamento.coletaInfraestruturaId = null

            this._supressLoadVagas = true

            this.$nextTick().then(() => {

                this.setLoading()

                this.repositories.agendamento.getAgendamento(item.agendamentoId)
                    .then(({ data }) => {

                        this.agendamento = {
                            ...data,
                            alterarAgendamento: item.alterarAgendamento,
                            showInfo: true,
                            supervisor: true,
                            impressao: true,
                            carregaJornada: true,
                        }

                        this.horarioAgendamento = data.horaInicial
                        this.tabIndex = 0
                    })
                    .catch(this.handleError)
                    .finally(() => {
                        this.unsetLoading(),
                        this._supressLoadVagas = false
                        this.loadVagas()
                    })
            })
        },
        handleReagendar() {

            this.agendamento.coletaInfraestruturaId = null

            this.$nextTick().then(() => {

                this.setLoading()

                this.repositories.agendamento.getAgendamento(this.reagendar.agendamentoId)
                    .then(({ data }) => {

                        this.agendamento.reagendar = true

                        this.agendamento.infraestruturaId = data.infraestruturaId
                        this.agendamento.unidadeId = data.unidadeId
                        this.agendamento.laboratorioId = data.laboratorioId
                        this.agendamento.laboratorioInfraestruturaId = data.laboratorioInfraestruturaId
                        this.agendamento.medicoSolicitante = data.medicoSolicitante
                        this.agendamento.responsavel = data.responsavel
                        this.agendamento.urgente = data.urgente
                        this.agendamento.coletaUnidadeId = data.coletaUnidadeId
                        this.agendamento.coletaInfraestruturaId = data.coletaInfraestruturaId
                        this.agendamento.medicamentos = data.medicamentos
                        this.agendamento.suspeita = data.suspeita
                        this.agendamento.observacao = data.observacao

                        this.reagendar.exames.forEach(exame => {

                            if (exame.pertenceGrupo) {

                                data.incluido
                                    .filter(grupo => grupo.grupoId == exame.exameGrupoId && grupo.mapaAgrupado)
                                    .forEach(grupo => {

                                        const incluir = grupo
                                        incluir.id = null
                                        this.agendamento.incluido.push(incluir)
                                    })
                            } else {

                                const incluir = data.incluido.find(i => i.exameId == exame.exameGrupoId)

                                if (incluir) {
                                    incluir.id = null;
                                    this.agendamento.incluido.push(incluir)
                                }
                            }
                        });

                        if (this.form.unidadesParametrizada && this.form.unidadesParametrizada.length > 0) {

                            const existe = this.form.unidadesParametrizada
                                .find(unidade => unidade.coleta && unidade.id == data.coletaUnidadeId
                                    && unidade.infraestruturas.find(infraestrutura =>
                                        infraestrutura.id == data.coletaInfraestruturaId
                                        && infraestrutura.unidadeSolicitanteInfraestruturaId == data.infraestruturaId
                                    )
                                )

                            if (!existe) {

                                this.agendamento.coletaUnidadeId = null
                                this.agendamento.coletaInfraestruturaId = null

                                this.showWarningNotification('A unidade de coleta não está disponível para seleção.')
                            }
                        } else {

                            this.agendamento.coletaUnidadeId = null
                            this.agendamento.coletaInfraestruturaId = null
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())

                this.agendamento.showInfo = true
                this.agendamento.supervisor = true
                this.agendamento.impressao = true
                this.tabIndex = 0
            })
            .then(() => this.loadVagas())
        },
        loadVagas() {

            this.vagas = []
            this.jornadas = []
            this.datasBloqueadas = []

            if (this.agendamento.coletaInfraestruturaId && this.tabIndex == 0) {

                this.setLoading()

                this.repositories.agendamento.getJornadas({unidade_id: this.agendamento.coletaUnidadeId,
                    infraestrutura_id: this.agendamento.coletaInfraestruturaId})
                        .then(response => {
                            this.vagas = response.data.agendamentos
                            this.jornadas = response.data.jornadas
                            this.datasBloqueadas = response.data.datasBloqueadas
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading(this.$nextTick(() => this.loadCalendario(this.agendamento.data))))
            }
        },
        loadCalendario(data){

            let diasCalendario = []

            let dataAtual = this.form.dataAtual
            dataAtual = dataAtual.split("/").reverse().join("-")

            if (this.jornadas.length == 0) {
                this.showValidationNotification("Não existe jornada cadastrada para o local de coleta selecionado.")
                return false
            }

            const agendamentosDoPaciente = this.model.agendamentos.filter(a => a.pacienteId === this.paciente.id);
            const datasAgendadasDoPaciente = agendamentosDoPaciente && agendamentosDoPaciente.map(a => moment(a.data).format("DD/MM/YYYY"));

            this.jornadas.map(unidade => {
                const pacienteEstaAgendado = datasAgendadasDoPaciente.includes(unidade.data);
                const unidadeDataFormatada = unidade.data.split("/").reverse().join("-");
                const feriado = this.form.feriados.find(feriado =>
                    feriado.data === unidade.data
                    && (feriado.abrangencia === this.enums.abrangencia.TODAS || feriado.infraestruturaIds.includes(this.agendamento.coletaInfraestruturaId))
                );
                const isFeriado = !!feriado;
                const dataBloqueada = this.datasBloqueadas.find(data => data === unidade.data);
                const isDataBloqueada = !!dataBloqueada;

                if (isFeriado) {
                    diasCalendario.push({
                        'dates': moment(unidade.data, 'DD/MM/YYYY').toDate(),
                        'highlight': 'yellow',
                        'title': feriado.tipoNome,
                        'popover': feriado.observacao,
                        'clickable': false
                    });
                    return;
                }

                if (isDataBloqueada) {
                    diasCalendario.push({
                        'clickable': false,
                        'dates': moment(unidade.data, 'DD/MM/YYYY').toDate(),
                        'highlight': 'red',
                        'popover': 'Data bloqueada para agendamento.',
                        'title': 'Bloqueada',
                    });
                    return;
                }

                if (moment(unidadeDataFormatada).isAfter(dataAtual) || unidadeDataFormatada == dataAtual) {
                    if (data && data == unidadeDataFormatada) {
                        let vagas = this.loadQuantidadeVagas(unidade);
                        diasCalendario.push({
                            'dates': data.split("-").reverse().join("/"),
                            'title': `${this.loadJornada(unidade)}/${vagas}`,
                            'highlight': 'blue',
                        });
                    } else {
                        let vagas = this.loadQuantidadeVagas(unidade);
                        diasCalendario.push({
                            'dates': moment(unidade.data, 'DD/MM/YYYY').toDate(),
                            'title': `${this.loadJornada(unidade)}/${vagas}`,
                            'highlight': pacienteEstaAgendado ? 'purple' : (this.loadJornada(unidade) >= vagas ? 'red' : 'green'),
                        });
                    }
                } else {
                    let vagas = this.loadQuantidadeVagas(unidade);
                    diasCalendario.push({
                        'dates': moment(unidade.data, 'DD/MM/YYYY').toDate(),
                        'title': `${this.loadJornada(unidade)}/${vagas}`,
                        'highlight': pacienteEstaAgendado ? 'purple' : 'gray',
                        'fillMode': 'light',
                    });
                }
            });

            this.form.feriados
                .filter(feriado => feriado.abrangencia === this.enums.abrangencia.TODAS || feriado.infraestruturaIds.includes(this.agendamento.coletaInfraestruturaId))
                .forEach(feriado => {
                    diasCalendario.push({
                        'dates': moment(feriado.data, 'DD/MM/YYYY').toDate(),
                        'highlight': 'yellow',
                        'title': feriado.tipoNome,
                        'popover': feriado.observacao,
                        'clickable': false
                    });
                });

            this.datasBloqueadas.map(dataBloqueada => {
                diasCalendario.push({
                    'clickable': false,
                    'dates': moment(dataBloqueada, 'DD/MM/YYYY'),
                    'highlight': 'red',
                    'popover': 'Data bloqueada para agendamento.',
                    'title': 'Bloqueada',
                })
            })

            this.diasCalendario = diasCalendario;
        },
        loadJornada(unidade) {

            return this.vagas.filter(item => item.data === unidade.data).length;
        },
        loadQuantidadeVagas(unidade) {

            let quantidade = this.jornadas.filter(item => item.data === unidade.data)
                .reduce((sum, element) => {

                    if (element.vagas) {
                        sum = sum + Number(element.vagas) + Number(element.vagasApp || 0);
                    }

                    return sum;
                },0)

            return quantidade
        },
        backTabs(){

            if( this.index != null){

                this.tabIndex = 1
            }

            this.setAgendamento()
        },
        messageAdd(){

            this.setAgendamento()

            if( this.index != null){

                this.showSaveNotification('Registro da agendamento selecionada alterada com sucesso.')

            } else {

                this.showSaveNotification('Registro do agendamento adicionado.')
            }
        },
        validate() {

            return this.tabRefs[this.tabIndex].validate()
        },
        loadDays() {

            let diasCalendario = []

            this.form.feriados
                .filter(feriado => feriado.abrangencia === this.enums.abrangencia.TODAS || feriado.infraestruturaIds.includes(this.agendamento.coletaInfraestruturaId))
                .forEach(feriado =>

                    diasCalendario.push({
                        'dates': moment(feriado.data, 'DD/MM/YYYY').toDate(),
                        'highlight': 'yellow',
                        'title': feriado.tipoNome,
                        'popover':  feriado.observacao
                    })
                )

            this.datasBloqueadas.map(dataBloqueada => {
                diasCalendario.push({
                    'clickable': false,
                    'dates': moment(dataBloqueada, 'DD/MM/YYYY'),
                    'highlight': 'red',
                    'popover': 'Data bloqueada para agendamento.',
                    'title': 'Bloqueada',
                })
            })

            this.loadDiasCalendario(diasCalendario)
        },
        loadDiasCalendario(value) {

            this.diasCalendario = value
        },
        handlePrintItem(item) {
            if (item.agendamentoNumero) {

                if (item.impressaoAgendamentoTipoId == this.enums.impressaoAgendamento.PROTOCOLO) {
                    this.handlePrint(item)
                } else if (item.impressaoAgendamentoTipoId == this.enums.impressaoAgendamento.ETIQUETA) {
                    this.handleEtiquetaPrint(item)
                } else {
                    this.handlePrint(item)
                    this.handleEtiquetaPrint(item)
                }
            }
        },
        handleEtiquetaPrint(item) {

            let etiqueta = {
                pacienteNome: item.pacienteNome,
                pacienteNomeSocial: item.pacienteNomeSocial,
                agendamentoNumero: item.agendamentoNumero,
                unidadeNome: item.unidade,
                laboratorioNome: item.laboratorio,
                idade: item.idade,
                prontuario: item.prontuario,
                sistemaNome: item.sistemaNome,
                sistemaVersao: item.sistemaVersao,
                nomePrefeitura: item.nomePrefeitura,
            }

            this.print().etiqueta(etiqueta)
        },
        handlePrint(item) {

            let agendamento = {
                pacienteNome: item.pacienteNome,
                pacienteNomeSocial: item.pacienteNomeSocial,
                prontuario: item.prontuario,
                cpf: this.formatCpf(item.cpf),
                nomeResponsavel: item.nomeResponsavel,
                dataNascimento: item.dataNascimento,
                agendamentoNumero: item.agendamentoNumero,
                medicoNome: item.medicoNome,
                data: item.data,
                examesIncluido: item.examesIncluido,
                horaExame: item.horaExame,
                unidade: item.unidade,
                observacao: item.observacao,
                endereco: item.endereco,
                numeroEndereco: item.numeroEndereco,
                bairro: item.bairro,
                telefone: item.telefone,
                tipo: item.tipo,
                cep: item.cep,
                localColeta: item.localColeta,
                enderecoColeta: item.enderecoColeta,
                numeroEnderecoColeta: item.numeroEnderecoColeta,
                bairroColeta: item.bairroColeta,
                tipoColeta: item.tipoColeta,
                cepColeta: item.cepColeta,
                telefoneColeta: item.telefoneColeta,
                laboratorio: item.laboratorio,
                enderecoLaboratorio: item.enderecoLaboratorio,
                numeroEnderecoLaboratorio: item.numeroEnderecoLaboratorio,
                bairroLaboratorio: item.bairroLaboratorio,
                tipoLaboratorio: item.tipoLaboratorio,
                cepLaboratorio: item.cepLaboratorio,
                telefoneLaboratorio: item.telefoneLaboratorio,
                logotipo: item.logotipo,
                nomePrefeitura: item.nomePrefeitura,
                ramoAtividade: item.ramoAtividade,
                mensagemProtocolo: item.mensagemProtocolo,
                sistemaNome: item.sistemaNome,
                sistemaVersao: item.sistemaVersao,
                usuario: item.usuario,
                usuarioNomeSocial: item.usuarioNomeSocial ? item.usuarioNomeSocial : null,
                urgente: item.urgente,
                dataEntrega: item.dataEntrega,
                regulacaoMensagemComprovanteAgendamento: item.regulacaoMensagemComprovanteAgendamento,
                regulacaoSolicitacaoNumero: item.regulacaoSolicitacaoNumero,
            }

            this.print().agendamento(agendamento)
        },
        reloadPaciente(paciente) {

            const racaCorMap = {
                [this.enums.racaCor.BRANCA]: 'BRANCA',
                [this.enums.racaCor.NEGRA]: 'PRETA',
                [this.enums.racaCor.AMARELA]: 'PARDA',
                [this.enums.racaCor.PARDA]: 'AMARELA',
                [this.enums.racaCor.INDIGENA]: 'INDIGINA',
                [this.enums.racaCor.SEM_INFORMACAO]: 'SEM INFORMAÇÃO'
            };

            this.paciente.cns = this.formatCns(paciente.cidadao.cns);
            this.paciente.cpf = this.formatCpf(paciente.cidadao.cpf);
            this.paciente.dataNascimento = moment(paciente.cidadao.dataNascimento).format('DD/MM/YYYY');
            this.paciente.telefone = this.handlePhone(paciente.cidadao.telefones)
            this.paciente.nome = paciente.cidadao.nome;
            this.paciente.nomeMae = paciente.cidadao.nomeMae;
            this.paciente.nomeSocial = paciente.cidadao.nomeSocial;
            this.paciente.protuario = paciente.prontuario;
            this.paciente.racaCor = racaCorMap[paciente.cidadao.racaCorId];
            this.paciente.rg = paciente.cidadao.rg;
            this.paciente.sexoDescricao = paciente.cidadao.sexo.descricao;
            this.paciente.sexoId = paciente.cidadao.sexo.id;
            this.paciente.anos = paciente.cidadao.idade.anos
            this.paciente.meses = paciente.cidadao.idade.meses
            this.paciente.dias = paciente.cidadao.idade.dias
        },
        handlePhone(obj) {
            let telefones = '';

            obj.forEach((item, i) => {
                if (i === 0) {
                    telefones = telefones.concat(this.formatPhoneOrCellPhone(item.numero));
                } else {
                    telefones = telefones.concat(`, ${this.formatPhoneOrCellPhone(item.numero)}`);
                }
            });

            return telefones;
        },
        openModalPaciente() {

            this.$refs.ModalPacienteCadastroSimplificado.open(this.paciente.id)
        },
        multipleAmbulatorioAtendimento(examesSelecionados) {

            const exames = examesSelecionados.filter(exame => exame.selecionado);

            if (exames.length == 1) {

                const item = exames.find(exame => exame.selecionado);

                this.agendamento.medicoSolicitante = {
                    id: item.profissionalId,
                    cidadaoNome: item.profissionalNome,
                }

                if (this.unidades.find(u => u.id === item.unidadeId)) {

                    this.agendamento.unidadeId = item.unidadeId
                    this.agendamento.infraestruturaId = item.infraestruturaId

                    this.setFields('unidade')
                }  else {

                    this.showWarningNotification('A unidade solicitante não está disponível para seleção.')
                }

                const param = {
                    id: this.uniqueId('exame' + new Date().getTime()),
                    checked: true,
                    exameId: item.exameId,
                    nome: item.exameNome,
                    codigo: item.exameCodigo,
                    supervisorId: item.supervisorId ?? null,
                    observacao: item.exameObservacao,
                    prazoEntrega: item.examePrazoEntrega,
                    procedimentoId: item.exameProcedimentoId,
                    valor: item.exameValorSigtap ? item.exameValorServicoAmbilatorial : item.exameValor,
                    statusId: null,
                    ambulatorioAtendimentoId: item.exameItemId ?? null,
                    acompanhamentoOciId: item.acompanhamentoOciId ?? null,
                }

                this.agendamento.incluido.push(param)
                this.agendamento.showInfo = true
                this.agendamento.impressao = true
            } else {

                const exames = examesSelecionados.filter(exame => exame.selecionado);

                const profissionalId = exames[0].profissionalId;
                const profissionais = exames.every(exame => exame.profissionalId === profissionalId);
                const infraestruturaId = exames[0].infraestruturaId;
                const unidadeId = exames[0].unidadeId;
                const infraestruturas = exames.every(exame => exame.infraestruturaId === infraestruturaId);

                if (profissionais) {

                    this.agendamento.medicoSolicitante = {
                        id: exames[0].profissionalId,
                        cidadaoNome: exames[0].profissionalNome,
                    }
                }

                if (infraestruturas) {

                    if (this.unidades.find(u => u.id === unidadeId)) {

                        this.agendamento.unidadeId = unidadeId
                        this.agendamento.infraestruturaId = infraestruturaId

                        this.setFields('unidade')
                    }  else {

                        this.showWarningNotification('A unidade solicitante não está disponível para seleção.')
                    }
                }

                exames.forEach(item => {

                    const param = {
                        id: this.uniqueId('exame' + new Date().getTime()),
                        checked: true,
                        exameId: item.exameId,
                        nome: item.exameNome,
                        codigo: item.exameCodigo,
                        supervisorId: item.supervisorId ?? null,
                        observacao: item.exameObservacao,
                        prazoEntrega: item.examePrazoEntrega,
                        procedimentoId: item.exameProcedimentoId,
                        valor: item.exameValorSigtap ? item.exameValorServicoAmbilatorial : item.exameValor,
                        statusId: null,
                        ambulatorioAtendimentoId: item.exameItemId ?? null,
                        acompanhamentoOciId: item.acompanhamentoOciId ?? null
                    }

                    this.agendamento.incluido.push(param)
                });

                this.agendamento.showInfo = true
                this.agendamento.impressao = true
                this.agendamento.ambulatorioAtendimento = true
            }
        },
        agendarAmbulatorioAtendimento(item) {

            this.agendamento.medicoSolicitante = {
                id: item.profissionalId,
                cidadaoNome: item.profissionalNome,
            }

            if (this.unidades.find(u => u.id === item.unidadeId)) {

                this.agendamento.unidadeId = item.unidadeId
                this.agendamento.infraestruturaId = item.infraestruturaId

                this.setFields('unidade')
            }  else {

                this.showWarningNotification('A unidade solicitante não está disponível para seleção.')
            }

            const param = {
                id: this.uniqueId('exame' + new Date().getTime()),
                checked: true,
                exameId: item.exameId,
                nome: item.exameNome,
                codigo: item.exameCodigo,
                supervisorId: item.supervisorId ?? null,
                observacao: item.exameObservacao,
                prazoEntrega: item.examePrazoEntrega,
                procedimentoId: item.exameProcedimentoId,
                valor: item.exameValorSigtap ? item.exameValorServicoAmbilatorial : item.exameValor,
                statusId: null,
                ambulatorioAtendimentoId: item.exameItemId ?? null,
                acompanhamentoOciId: item.acompanhamentoOciId ?? null
            }

            this.agendamento.incluido.push(param)
            this.agendamento.showInfo = true
            this.agendamento.impressao = true
        }
    },
    mixins: [formats, repository, stringCase, data, object, error, printExameLaboratorial],
    props: {
        id: { type: Number },
        hideAgendamentos: { type: Boolean, default: false },
        hasPrint: { type: Boolean, default: false },
        hasAmbulatorio: { type: Boolean, default: false },
        regulacaoSolicitacao: { type: Object },
        reagendar: { type: Object },
    },
    mounted() {
        this.load()
    },
}
</script>

<style>
.tabs {
    border: 0px solid #dee2e6!important;
    border-radius: 0.25rem;
}
</style>